import { InputComponentProps } from "components/Form/components/InputComponentProps";

export interface NumberProps {
    name: string;
    inputProps: InputComponentProps<number>; // TODO optimize
    attributes?: any; // TODO consider improvement
}

export const Number = ({ name, inputProps, attributes }: NumberProps) => {
    // isReadOnly is a component-level prop, not a DOM attribute — keep it off the <input>.
    const { isReadOnly, ...domInputProps } = inputProps;
    const value = domInputProps.value == null ? "" : domInputProps.value;
    return (
        <input
            {...domInputProps}
            {...attributes}
            value={value}
            aria-label={`${name}`}
            type="number"
            className="input__field"
            disabled={isReadOnly}
        />
    );
};
